import { render, staticRenderFns } from "./MixedForm.vue?vue&type=template&id=bf4d3a44&scoped=true&"
import script from "./MixedForm.vue?vue&type=script&lang=js&"
export * from "./MixedForm.vue?vue&type=script&lang=js&"
import style0 from "./MixedForm.vue?vue&type=style&index=0&id=bf4d3a44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4d3a44",
  null
  
)

export default component.exports